import { render } from "./testpal-ai.vue?vue&type=template&id=14b944cc&scoped=true"
import script from "./testpal-ai.vue?vue&type=script&lang=js"
export * from "./testpal-ai.vue?vue&type=script&lang=js"

import "./testpal-ai.vue?vue&type=style&index=0&id=14b944cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b944cc"]])

export default __exports__